import { useState } from 'react';
import dayjs from 'dayjs';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';

/**
 * Downloads the CSV of the guests who consented to marketing mail. The file is named here rather
 * than read from Content-Disposition, which a cross-origin API does not expose to the page.
 */
const useExportMarketingContacts = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  const exportMarketingContacts = async () => {
    setLoading(true);

    try {
      const response = await apiClient.get(`/v1/tenants/${tenantId}/marketing-contacts/export`, { responseType: 'blob' });
      saveFile(response.data, `${tenantId}-feliratkozok-${dayjs().format('YYYY-MM-DD')}.csv`);
    } catch (error) {
      handleError(await withJsonErrorBody(error), Routes.DASHBOARD_GUESTS);
    } finally {
      setLoading(false);
    }
  };

  return { exportMarketingContacts, loading };
};

const saveFile = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

// Asked for a blob, the error answer arrives as one too; useErrorHandler reads its message from JSON.
const withJsonErrorBody = async (error) => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) return error;

  try {
    error.response.data = JSON.parse(await data.text());
  } catch {
    // Not JSON: the handler falls back to its general message.
  }
  return error;
};

export default useExportMarketingContacts;
